import { render, staticRenderFns } from "./mint.vue?vue&type=template&id=22431c5d&scoped=true&"
import script from "./mint.vue?vue&type=script&lang=ts&"
export * from "./mint.vue?vue&type=script&lang=ts&"
import style0 from "./mint.vue?vue&type=style&index=0&id=22431c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22431c5d",
  null
  
)

export default component.exports